import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../../api';
import "parsleyjs";
import $ from "jquery";
import {capitalize} from "../../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {user, getUserReport} from "../../../api/app";
import formatNumber from "../../../utils/formatNumber";
import {useSelector} from "react-redux";

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'mobile_number', isNumeric: true }
]

const Member = () => {

    document.title = "Member";

    const token = localStorage.getItem('jwtToken');
    const auth = useSelector((state) => state.auth.user);
    const [id, setId] = useState(new Date().getTime());

    const [stateReady, setStateReady] = useState(false);

    useEffect(() => {
        getUserReport().then((response) => {
            if(!response.error) {
                $('#total-users').text(formatNumber(response.payload.total_users, "digit"));
                $('#total-assignment').text(formatNumber(response.payload.total_assignments, "digit"));
                $('#total-submission').text(formatNumber(response.payload.total_submissions, "digit"));
            }
        });
    }, []);

    useEffect(() => {
        const element = $("#user_table")[0];
        const datatable = new window.KTDataTable(element, {
            apiEndpoint: GET_COLLECTION_AGGREGATE_DATA,
            requestMethod: "GET",
            requestHeaders: {
                "Authorization": token
            },
            pageSize: 10,
            pageSizes: [10, 20],
            mapRequest: (params) => {
                const p = Object.fromEntries(params);
                const page = parseInt(p.page || 1);
                const size = parseInt(p.size || 10);
                const offset = (page - 1) * size;

                const query = new URLSearchParams({
                    collection: "user",
                    searchableFields: JSON.stringify(searchableFields),
                    query: "",
                    pageSize: offset,
                    limit: size,
                    filter: JSON.stringify({
                        admin: auth.user.role === "admin" ? {} : `ObjectId(${auth.user.sub})`
                    })
                });
                return query.toString();
            },
            mapResponse: (response) => {
                return {
                    data: response.data,
                    totalCount: response.total
                };

            },
            search: {
                delay: 300,
                callback: (data, query) => {
                    console.log(query);
                    return data.filter(item =>
                        item.name.toLowerCase().includes(query.toLowerCase())
                    );
                }
            },
            columns: {
                name: {
                    title: "Name",
                    render: (value, row) => {
                        return `<a class="text-sm font-medium text-mono hover:text-primary" href="#">${capitalize(row.name)}</a>`
                    }
                },
                mobile_number: {
                    title: "Mobile",
                    render: (value, row) => row.mobile_number.toString()
                },
                team: {
                    title: "Team",
                    render: (value, row) => 'Sam'
                },
                app: {
                    title: "Team",
                    render: (value, row) => {
                        return `<div class="flex flex-wrap gap-2">
                            <img alt="" class="size-[18px] shrinc-0" src="assets/media/brand-logos/facebook.svg"/>
                             <img alt="" class="size-[18px] shrinc-0" src="assets/media/brand-logos/tiktok-2.svg"/>
                              <img alt="" class="size-[18px] shrinc-0" src="assets/media/brand-logos/x.svg"/>
                              <img alt="" class="size-[18px] shrinc-0" src="assets/media/brand-logos/instagram-2.svg"/>
                          </td>`
                    }
                },
                date: {
                    title: "Date",
                    render: (value, row) => moment(row.date.iso).format("Do MMM, YYYY")
                },
                actions: {
                    title: "Actions",
                    render: (value, row) => {
                        return `
                            <div class="kt-menu flex-inline" data-kt-menu="true">
                                <div class="kt-menu-item" data-kt-menu-item-offset="0, 10px" data-kt-menu-item-placement="bottom-end" data-kt-menu-item-placement-rtl="bottom-start" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click">
                                 <button class="kt-menu-toggle kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
                                  <i class="ki-filled ki-dots-vertical text-lg">
                                  </i>
                                 </button>
                                 <div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px]" data-kt-menu-dismiss="true">
                                  <div class="kt-menu-item">
                                   <a class="kt-menu-link" href="#/user/${row._id}">
                                    <span class="kt-menu-icon">
                                     <i class="ki-filled ki-search-list">
                                     </i>
                                    </span>
                                    <span class="kt-menu-title">
                                     View
                                    </span>
                                   </a>
                                  </div>
                                  <div class="kt-menu-separator">
                                  </div>
                                  <div class="kt-menu-item">
                                   <a class="kt-menu-link" href="#" class="nav-link delete_user" data-id="${row._id}" data-name="${row.name}">
                                    <span class="kt-menu-icon">
                                     <i class="ki-filled ki-trash">
                                     </i>
                                    </span>
                                    <span class="kt-menu-title">
                                     Remove
                                    </span>
                                   </a>
                                  </div>
                                 </div>
                                </div>
                               </div>
                            `
                    }
                }

            }

        });

        // Delete user event
        element.addEventListener("click", function(e){
            e.preventDefault();
            const btn = e.target.closest(".delete_user");
            if(!btn) return;

            const id = btn.dataset.id;
            const name = btn.dataset.name;

            $(".data-message").text(`Are you sure, you want to delete this user, ${name}?`);

            $("#delete-data").off("click").on("click", function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                user("delete", {id}).then((result) => {

                    hide();

                    if(!result.error){
                        datatable.reload();
                        cogoToast.success("User successfully removed.", {position: "top-right"});
                    }

                });

            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });

        });


        return () => {
            datatable.dispose();
        };

    }, []);

    const handleShowModal = () => {
        const element = $("#create-modal")[0];
        if(!element) return;
        let modal = window.KTModal.getInstance(element);
        if(!modal) modal = new window.KTModal(element);
        $("#user-form").parsley();
        modal.show();
    }

    const handleLeaderboard = () => {
        setId(new Date().getTime());
        $("#modalLeaderboard").modal("show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        parsley.reset();
        parsley.destroy();

        const element = $(`#${id}`)[0];
        if (!element) return;
        const modal = window.KTModal.getInstance(element);
        if (modal) modal.hide();
    }

    const handleCreateUserSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let mobile_number = $('#mobile').val();
        let password = $('#password').val();

        setStateReady(true);

        let data = {
            name,
            mobile_number,
            password
        };

        user("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("User successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("create-modal", "user-form");
                reloadTable();
            }
        });
    }

    const reloadTable = () => {
        // $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div>
            <div className="kt-container-fixed">
                <div className="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div className="flex flex-col justify-center gap-2">
                        <h1 className="text-xl font-medium leading-none text-mono">
                            Members
                        </h1>
                        <div className="flex items-center gap-2 text-sm font-normal text-secondary-foreground">
                            Central Hub for Personal Customization
                        </div>
                    </div>
                    <div className="flex items-center gap-2.5">
                        <a className="kt-btn kt-btn-primary" href="javascript:void(0)" onClick={handleShowModal.bind()}>
                            <span className="kt-menu-icon"><i className="ki-filled ki-plus"></i></span><span
                            className="kt-menu-title">Create</span>
                        </a>
                    </div>
                </div>
            </div>

            <div className="kt-container-fixed">
                <div className="kt-card kt-card-grid h-full min-w-full">
                    <div className="kt-card-header">
                        <h3 className="kt-card-title">Members</h3>
                        <div className="kt-input max-w-48">
                            <i className="ki-filled ki-magnifier"></i>
                            <input data-kt-datatable-search="#kt_datatable_1" placeholder="Search Teams"
                                   type="text"></input>
                        </div>
                    </div>
                    <div className="kt-card-table">
                        <div className="grid" data-kt-datatable="true" data-kt-datatable-page-size="5" id="user_table">
                            <div className="kt-scrollable-x-auto">
                                <table className="kt-table kt-table-border table-fixed" data-kt-datatable-table="true"
                                       id="kt_datatable_1">
                                    <thead>
                                    <tr>
                                        <th className="w-[200px]">
                                            <span className="kt-table-col">
                                                <span className="kt-table-col-label">Name</span>
                                                <span className="kt-table-col-sort"></span>
                                            </span>
                                        </th>
                                        <th className="w-[165px]">
                                            <span className="kt-table-col">
                                                <span className="kt-table-col-label">Phone</span>
                                                <span className="kt-table-col-sort"></span>
                                            </span>
                                        </th>
                                        <th className="w-[165px]">
                                            <span className="kt-table-col">
                                                <span className="kt-table-col-label">Team Leader</span>
                                                <span className="kt-table-col-sort"></span>
                                            </span>
                                        </th>
                                        <th className="w-[165px]">
                                            <span className="kt-table-col">
                                                <span className="kt-table-col-label">Connected App</span>
                                                <span className="kt-table-col-sort"></span>
                                            </span>
                                        </th>
                                        <th className="w-[165px]">
                                            <span className="kt-table-col">
                                                <span className="kt-table-col-label">Joined</span>
                                                <span className="kt-table-col-sort"></span>
                                            </span>
                                        </th>
                                        <th className="w-[60px]">
                                        </th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                            <div
                                className="kt-card-footer justify-center md:justify-between flex-col md:flex-row gap-5 text-secondary-foreground text-sm font-medium">
                                <div className="flex items-center gap-2 order-2 md:order-1">
                                    Show
                                    <select className="kt-select w-16" data-kt-datatable-size="true" data-kt-select=""
                                            name="perpage"></select>per page
                                </div>
                                <div className="flex items-center gap-4 order-1 md:order-2">
                                    <span data-kt-datatable-info="true"></span>
                                    <div className="kt-datatable-pagination" data-kt-datatable-pagination="true"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="kt-modal"
                data-kt-modal="true"
                data-kt-modal-backdrop-static="true"
                id="create-modal"
            >
                <div className="kt-modal-content max-w-[650px] top-[10%]">
                    <div className="kt-modal-header">
                        <div className="d-flex">
                            <h3 className="kt-modal-title">Create User</h3>
                            <p className="gap-2 text-sm font-normal text-secondary-foreground">Add members or influencer to the system.</p>
                        </div>
                        <button
                            type="button"
                            className="kt-modal-close"
                            aria-label="Close modal"
                            onClick={resetForm.bind(null, "create-modal", "user-form")}
                            data-kt-modal-dismiss="#modal"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x" aria-hidden="true">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <div className="kt-modal-body">
                        <form id="user-form" className="kt-card-content flex flex-col gap-5 parsley-style-1" data-parsley-validate="true" onSubmit={handleCreateUserSubmit.bind()}>
                            <div className="flex flex-col gap-1">
                                <label className="kt-form-label font-normal text-mono">Full Name</label>
                                <input id="name" className="kt-input kt-input-lg" placeholder="Enter full name" type="text" required/>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="kt-form-label font-normal text-mono">Mobile Number</label>
                                <input id="mobile" className="kt-input kt-input-lg" placeholder="Enter mobile number" type="text" required/>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="kt-form-label font-normal text-mono">Password</label>
                                <input id="password" className="kt-input kt-input-lg" placeholder="Enter Password" type="password" autoComplete="off" maxLength="4" pattern="[0-9]{4}" inputMode="numeric" required/>
                            </div>
                            {stateReady ? <button id="submitBtn" className="kt-btn kt-btn-primary" disabled>
                                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                <span className="indicator-label">Please Wait</span>
                            </button> : <button className="kt-btn kt-btn-primary kt-btn-lg flex justify-center grow">Add Member</button>}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Member;
